const PRACTICE_TRACKING_PARAMETERS = new Set([
  "dclid",
  "fbclid",
  "gclid",
  "msclkid",
  "utm_campaign",
  "utm_content",
  "utm_id",
  "utm_medium",
  "utm_source",
  "utm_term",
]);

export function getPracticeBoardFromPath(pathname: string): number | null {
  const finalSegment = pathname.replace(/\/+$/, "").split("/").pop() || "";
  if (!/^\d+$/.test(finalSegment)) {
    return null;
  }
  const board = Number(finalSegment);
  return Number.isInteger(board) && board >= 1 ? board : null;
}

export function buildPracticeBoardAddress(
  practicePath: string,
  currentAddress: string,
  strategySlug: string,
  boardIndex: number,
) {
  const currentUrl = new URL(currentAddress);
  const practiceUrl = new URL(practicePath, currentUrl.origin);

  const basePath = practiceUrl.pathname.replace(/\/+$/, "");
  practiceUrl.pathname = `${basePath}/${strategySlug}${
    boardIndex > 0 ? `/${boardIndex + 1}` : ""
  }`;
  practiceUrl.search = "";

  currentUrl.searchParams.forEach((value, key) => {
    if (PRACTICE_TRACKING_PARAMETERS.has(key)) {
      practiceUrl.searchParams.append(key, value);
    }
  });

  practiceUrl.hash = "";

  return practiceUrl;
}
